import Typography from "typography"
// import Wordpress2016 from "typography-theme-wordpress-2016"

import GitHubTypography from "typography-theme-github";

GitHubTypography.overrideThemeStyles = () => {
  return {
    "a.gatsby-resp-image-link": {
      boxShadow: `none`,
    },
  }
}

delete GitHubTypography.googleFonts

const typography = new Typography(GitHubTypography)

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
